import { render, staticRenderFns } from "./CabecalhoPrincipal.vue?vue&type=template&id=40b07cbc&scoped=true"
import script from "./CabecalhoPrincipal.vue?vue&type=script&lang=js"
export * from "./CabecalhoPrincipal.vue?vue&type=script&lang=js"
import style0 from "./CabecalhoPrincipal.vue?vue&type=style&index=0&id=40b07cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b07cbc",
  null
  
)

export default component.exports